module.exports = __webpack_public_path__ + "static/media/sm-x.01d75450.svg";